import { useSelector } from 'react-redux';
import { THEME } from '../constants/app-constants';
import { LocalSessionKey } from '../burger-king-lib/constants/app-constants';

function useBKLocation() {
  const location = useSelector(state => {
    const theme = sessionStorage.getItem(LocalSessionKey.THEME);
    const outletData = state?.cart?.outletData;
    if (theme === THEME.DELIVERY) {
      return outletData?.location;
    }
    if (theme === THEME.RESTAURANT) {
      const restaurantDetail = JSON.parse(
        window.sessionStorage.getItem('RESTAURANT_DETAIL')
      );
      return restaurantDetail?.outlet_name;
    }
    return outletData?.outlet_name;
  });

  return { location };
}

export default useBKLocation;
